const firstTimeModalNewVerificationCode = {
  'first-time-modal-new-verificaion-code-message': 'We have sent you a new verification code. Please open your email and complete the verification. Thank you for choosing us.'
};

export default firstTimeModalNewVerificationCode;
